import { useEffect } from "react";

interface Props {
  images: string[];
  index: number;
  onClose: () => void;
  onChange: (index: number) => void;
}

export default function ImagePreview({ images, index, onClose, onChange }: Props) {
  const total = images.length;

  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") onClose();
      if (e.key === "ArrowRight") onChange((index + 1) % total);
      if (e.key === "ArrowLeft") onChange((index - 1 + total) % total);
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [index, total, onClose, onChange]);

  return (
    <div className="fixed inset-0 z-[70] flex items-center justify-center bg-foreground-950/90 p-4">
      <button
        type="button"
        aria-label="关闭预览"
        onClick={onClose}
        className="absolute right-5 top-5 flex h-11 w-11 items-center justify-center rounded-full bg-background-50/10 text-background-50 transition-colors hover:bg-background-50/20"
      >
        <i className="ri-close-line text-2xl" />
      </button>

      <span className="absolute left-5 top-6 rounded-full bg-background-50/10 px-3 py-1 text-sm text-background-50">
        {index + 1} / {total}
      </span>

      {total > 1 && (
        <button
          type="button"
          aria-label="上一张"
          onClick={() => onChange((index - 1 + total) % total)}
          className="absolute left-4 flex h-11 w-11 items-center justify-center rounded-full bg-background-50/10 text-background-50 transition-colors hover:bg-background-50/20"
        >
          <i className="ri-arrow-left-s-line text-2xl" />
        </button>
      )}

      <img
        src={images[index]}
        alt={`爆料图片 ${index + 1}`}
        className="max-h-[82vh] max-w-[92vw] rounded-lg object-contain"
      />

      {total > 1 && (
        <button
          type="button"
          aria-label="下一张"
          onClick={() => onChange((index + 1) % total)}
          className="absolute right-4 flex h-11 w-11 items-center justify-center rounded-full bg-background-50/10 text-background-50 transition-colors hover:bg-background-50/20"
        >
          <i className="ri-arrow-right-s-line text-2xl" />
        </button>
      )}
    </div>
  );
}